import { render } from "./DocumentsListForSigned.vue?vue&type=template&id=13d300a6"
import script from "./DocumentsListForSigned.vue?vue&type=script&lang=js"
export * from "./DocumentsListForSigned.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__